import axios from "@/api/axiosInstance";
import {
  SaveCatalogCategoryRequest,
  SaveCatalogCategoryResponse,
} from "./types";

export const createCatalogCategory = async (
  payload: SaveCatalogCategoryRequest,
): Promise<SaveCatalogCategoryResponse> => {
  const response = await axios.post<SaveCatalogCategoryResponse>(
    "/api/private/product-catalog/categories",
    payload,
  );
  return response.data;
};
